import React from "react";
import * as actions from '../Actions';
import Service from '../../service/Service';
const service = new Service();
import ShareOptions from './ShareOptions';

export default function DiscussionLinks({ discussion, eleRef }) {
    
    return (
        <div className="discussion-links">
            <span className={discussion.isMyComment == 1 ? "M13_42 discussion_social_actions openParticipate is-active" : "M13_42 discussion_social_actions openParticipate"} onClick={() => actions.openParticipatePopup(discussion.discussionId, actions.only_title(discussion.title), discussion.discription, discussion.groupId, discussion.categoryId, discussion.urls && discussion.urls[0] ? discussion.urls[0].source : '')}>
                <div data-icon-font="&#xe01d;" className="icon dev_comment"></div>
                <span className="dev_comment">Comment</span>
            </span>
            <span className={discussion.isMyFollow == 1 ? "M13_42 discussion_social_actions discussion_follow is-active" : "M13_42 discussion_social_actions discussion_follow"} onClick={() => actions.followDiscussion(discussion.discussionId, discussion.userId, discussion.groupId, discussion.categoryId, discussion.isMyFollow == 1 ? 0 : 1, eleRef)}>
                <div data-icon-font="&#xe023;" className="icon dev_nowfollow"></div>
                {discussion.isMyFollow == 1 ?
                    <span>Followed</span> :
                    <span className="dev_nowfollow">Follow</span>
                }
            </span>
            <span className="M13_42 discussion_social_actions card-share" id={`share_${discussion.discussionId}`}>
                <div className="share-container" onClick={() => actions.shareOn(discussion.discussionId)}>
                    <div data-icon-font="&#xe027;" className="icon share-icon"></div>
                    <span className="share-text">Share</span>
                </div>
                <ShareOptions discussion={discussion} eleRef={this} />
            </span>
        </div>
    );
}



// WEBPACK FOOTER //
// src/shared/discussions/common/DiscussionLinks.js